import appStore from 'store';
import api from './api';


const store = {
  namespaced: true,
  state: {
    userList: [],
    totalCount: 0,
    pagination:  {
      page: 1,
      size: 25
    },

  },
  getters: {

  },
  mutations: {
    setUserList(state, payload) {
      state.userList = payload.list.slice();
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
  },
  actions: {
    list({ commit }, query = {}) {
      commit('setPagination', { page: query.page, size: query.size });
      api.getUserList(query).then(res => {
        console.log('verify-res',res);
        commit('setUserList', res.data);
      });
    },
  }
};

appStore.registerModule('userVerify', store);
